/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getIntelligentCustomerServiceConfig = params => {
  return axios.get(`${base}/setting/get_intelligent_customer_service`)
}
export const setIntelligentCustomerServiceConfig = params => {
  return axios.post(`${base}/setting/set_intelligent_customer_service`, params)
}



// WEBPACK FOOTER //
// ./src/views/intelligent-customer-service/intelligent-customer-service.api.js